export const salaryHistoryNamespace = 'salaryHistory';
export * from './api';
export * from './salaryHistory';
